import React from 'react';
export const RoomOptionGroupContext = React.createContext({
    onRoomDetailsClick: null,
    onSubBoardDetailsClick: null,
    hasInclusionDetails: false,
    selectedRoom: null,
});
export function useRoomOptionGroupContext() {
    return React.useContext(RoomOptionGroupContext);
}
